import { ON_DEMANDS_NEW_PATH } from 'cpmCarparks/navigation';

module.exports = {
  path: ON_DEMANDS_NEW_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./OnDemandsContainer'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/routes/show/routes/onDemandsNew/index.js